'use strict';

/**
 * A directive to apply style="background-image: url(URL)" while allowing for interpolation.
 * Example:
 * <div background-image="{{activity.image}}"></div>
 */
(function () {
  'use strict';

  angular.module('msCore').directive('backgroundImage', backgroundImage);

  function backgroundImage() {
    return function (scope, ele, attrs) {
      attrs.$observe('backgroundImage', function (img) {
        ele.css({
          'background-image': 'url(' + img + ')'
        });
      });
    };
  }
})();